// extracted by mini-css-extract-plugin
export default {"tab-label":"tab-label-2760"};